(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('cross-fetch')) :
    typeof define === 'function' && define.amd ? define(['exports', 'cross-fetch'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Relewise = {}, global.fetch));
})(this, (function (exports, fetch) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

    class DataValueBase {
        constructor(type, value) {
            this.type = type;
            this.value = value;
        }
    }
    class StringDataValue extends DataValueBase {
        constructor(value) {
            super('String', value);
            this.isCollection = false;
        }
    }
    class StringCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('StringList', {
                $type: 'System.Collections.Generic.List`1[[System.String, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class MultilingualCollectionDataValue extends DataValueBase {
        constructor(values) {
            super('MultilingualCollection', {
                $type: 'System.Collections.Generic.List`1[[Relewise.Client.DataTypes.Multilingual, Relewise.Client]], System.Private.CoreLib',
                $values: values.map(x => ({ values: x.values, language: { value: x.language } })),
            });
            this.isCollection = true;
        }
    }
    class NumberDataValue extends DataValueBase {
        constructor(value) {
            super('Double', value);
            this.isCollection = false;
        }
    }
    class DoubleCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('DoubleList', {
                $type: 'System.Collections.Generic.List`1[[System.Double, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class BooleanDataValue extends DataValueBase {
        constructor(value) {
            super('Boolean', value);
            this.isCollection = false;
        }
    }
    class BooleanCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('BooleanList', {
                $type: 'System.Collections.Generic.List`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class MultiCurrencyDataValue extends DataValueBase {
        constructor(values) {
            super('MultiCurrency', {
                $type: 'Relewise.Client.DataTypes.MultiCurrency, Relewise.Client',
                values: values.map(x => ({ amount: x.amount, currency: { value: x.currency } })),
            });
            this.isCollection = false;
        }
    }
    class MultilingualDataValue extends DataValueBase {
        constructor(values) {
            super('Multilingual', {
                $type: 'Relewise.Client.DataTypes.Multilingual, Relewise.Client',
                values: values.map(x => ({ text: x.value, language: { value: x.language } })),
            });
            this.isCollection = false;
        }
    }
    class ObjectDataValue extends DataValueBase {
        constructor(dataObject) {
            super('Object', {
                $type: 'Relewise.Client.DataTypes.DataObject, Relewise.Client',
                data: dataObject,
            });
            this.isCollection = false;
        }
    }
    class ObjectCollectionDataValue extends DataValueBase {
        constructor(dataObjects) {
            super('ObjectList', {
                $type: 'System.Collections.Generic.List`1[[Relewise.Client.DataTypes.DataObject, Relewise.Client]], System.Private.CoreLib',
                $values: dataObjects.map(x => ({ $type: 'Relewise.Client.DataTypes.DataObject, Relewise.Client', data: x })),
            });
            this.isCollection = true;
        }
    }

    class DataObjectFilterConditionBuilder {
        constructor() {
            this.conditions = [];
        }
        addContainsCondition(key, value, mode = 'All', objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueContainsCondition, Relewise.Client',
                key: key,
                value: value,
                objectPath: objectPath,
                mode: mode,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addEqualsCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueEqualsCondition, Relewise.Client',
                value: value,
                objectPath: objectPath,
                negated: negated,
                key: key,
            };
            this.conditions.push(condition);
            return this;
        }
        addInRangeCondition(key, range, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueInRangeCondition, Relewise.Client',
                range: range,
                key: key,
                objectPath: objectPath,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addGreaterThanCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueGreaterThanCondition, Relewise.Client',
                value: value,
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addLessThanCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueLessThanCondition, Relewise.Client',
                value: value,
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addMinByCondition(key, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueMinByCondition, Relewise.Client',
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addMaxByCondition(key, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueMaxByCondition, Relewise.Client',
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        build() {
            return this.conditions.length === 0
                ? null
                : this.conditions;
        }
    }

    class ConditionBuilder {
        constructor() {
            this.conditions = [];
        }
        addContainsCondition(value, valueCollectionEvaluationMode = 'All', negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client',
                value: value,
                valueCollectionEvaluationMode: valueCollectionEvaluationMode,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addDistinctCondition(numberOfOccurrencesAllowedWithTheSameValue, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.DistinctCondition, Relewise.Client',
                numberOfOccurrencesAllowedWithTheSameValue: numberOfOccurrencesAllowedWithTheSameValue,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addEqualsCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addGreaterThanCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.GreaterThanCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addLessThanCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.LessThanCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addDataObjectCondition(conditions, skip, take, negated = false) {
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            conditions(conditionsBuilder);
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client',
                objectFilter: {
                    conditions: conditionsBuilder.build(),
                    skip: skip,
                    take: take,
                },
                valueCollectionEvaluationMode: 'All',
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        build() {
            return this.conditions.length === 0
                ? null
                : { items: this.conditions };
        }
    }

    class FilterBuilder {
        constructor() {
            this.filters = [];
        }
        /**
         * Adds a product assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addProductAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a variant assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addVariantAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a brand assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addBrandAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content category assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addContentCategoryAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content category assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addProductCategoryAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within the specificed categories
         * @param evaluationScope
         * @param categoryIds
         * @param negated
         */
        addProductCategoryIdFilter(evaluationScope, categoryIds, negated = false) {
            const ids = Array.isArray(categoryIds)
                ? categoryIds
                : [categoryIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryIdFilter, Relewise.Client',
                evaluationScope: evaluationScope,
                categoryIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return contents within the specificed categories
         * @param evaluationScope
         * @param categoryIds
         * @param negated
         */
        addContentCategoryIdFilter(evaluationScope, categoryIds, negated = false) {
            const ids = Array.isArray(categoryIds)
                ? categoryIds
                : [categoryIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryIdFilter, Relewise.Client',
                evaluationScope: evaluationScope,
                categoryIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied products
         * @param productIds
         * @param negated
         */
        addProductIdFilter(productIds, negated = false) {
            const ids = Array.isArray(productIds)
                ? productIds
                : [productIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductIdFilter, Relewise.Client',
                productIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied variants
         * @param variantIds
         * @param negated
         */
        addVariantIdFilter(variantIds, negated = false) {
            const ids = Array.isArray(variantIds)
                ? variantIds
                : [variantIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantIdFilter, Relewise.Client',
                variantIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied brands
         * @param brandIds
         * @param negated
         */
        addBrandIdFilter(brandIds, negated = false) {
            const ids = Array.isArray(brandIds)
                ? brandIds
                : [brandIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandIdFilter, Relewise.Client',
                brandIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied contents
         * @param contentIds
         * @param negated
         */
        addContentIdFilter(contentIds, negated = false) {
            const ids = Array.isArray(contentIds)
                ? contentIds
                : [contentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentIdFilter, Relewise.Client',
                contentIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a range filter to the request ensuring the product has a certain range of variants
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductHasVariantsFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductHasVariantsFilter, Relewise.Client',
                numberOfVariants: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products purchased since a certain point in time
         * @param sinceUtc
         * @param negated
         */
        addProductRecentlyPurchasedByUserFilter(sinceUtc, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductRecentlyPurchasedByUserFilter, Relewise.Client',
                sinceUtc: sinceUtc,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products viewed since a certain point in time
         * @param sinceUtc
         * @param negated
         */
        addProductRecentlyViewedByUserFilter(sinceUtc, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductRecentlyViewedByUserFilter, Relewise.Client',
                sinceUtc: sinceUtc,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within a certain SalesPrice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductSalesPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductSalesPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within a certain ListPice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductListPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductListPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants within a certain SalesPrice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addVariantSalesPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantSalesPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants within a certain ListPice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addVariantListPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantListPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants with a certain specification
         * @param key
         * @param equalTo
         * @param filterOutIfKeyIsNotFound controls if variants with or without the key should be returned
         * @param negated
         */
        addVariantSpecificationFilter(key, equalTo, filterOutIfKeyIsNotFound = true, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantSpecificationFilter, Relewise.Client',
                key: key,
                equalTo: equalTo,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        and(filterBuilder, negated = false) {
            const builder = new FilterBuilder();
            filterBuilder(builder);
            const filters = builder.build();
            if (filters === null || filters.items === undefined || filters.items === null || filters.items.length <= 0) {
                throw new Error('And-filters must contain atleast 1 filter');
            }
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.AndFilter, Relewise.Client',
                filters: filters.items,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        or(filterBuilder, negated = false) {
            const builder = new FilterBuilder();
            filterBuilder(builder);
            const filters = builder.build();
            if (filters === null || filters.items === undefined || filters.items === null || filters.items.length <= 0) {
                throw new Error('Or-filters must contain atleast 1 filter');
            }
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.OrFilter, Relewise.Client',
                filters: filters.items,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a product data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addProductDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a variant data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addVariantDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a brand data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addBrandDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a cart data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addCartDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.CartDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a cart data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addContentCategoryDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addContentDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a product category data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addProductCategoryDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product display name filter to the request
        * @param key
        * @param conditionBuilder
        * @param mustMatchAllConditions
        * @param filterOutIfKeyIsNotFound
        * @param negated
        */
        addProductDisplayNameFilter(conditionBuilder, mustMatchAllConditions = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductDisplayNameFilter, Relewise.Client',
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product variant filter to the request
        * @param products
        * @param negated
        */
        addProductAndVariantIdFilter(products, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductAndVariantIdFilter, Relewise.Client',
                productAndVariantIds: Array.isArray(products) ? products : [products],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category level filter to the request
        * @param levels
        * @param negated
        */
        addProductCategoryLevelFilter(levels, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryLevelFilter, Relewise.Client',
                levels: Array.isArray(levels) ? levels : [levels],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has parent filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasParentFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasParentFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has child filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasChildFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasChildFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has ancestor filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasAncestorFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasAncestorFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category level filter to the request
        * @param levels
        * @param negated
        */
        addContentCategoryLevelFilter(levels, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryLevelFilter, Relewise.Client',
                levels: Array.isArray(levels) ? levels : [levels],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has parent filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasParentFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasParentFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has child filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasChildFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasChildFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has ancestor filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasAncestorFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasAncestorFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        reset() {
            this.filters = [];
            return this;
        }
        build() {
            return this.filters.length === 0
                ? null
                : { items: this.filters };
        }
    }

    class PaginationBuilder {
        constructor() {
            this.pageNumber = 1;
            this.pageSize = 10;
        }
        /**
         * Defines how many results to return
         * @param pageSize
         * @returns
         */
        setPageSize(pageSize) {
            if (pageSize < 0) {
                throw new Error('pageSize can not be below 0');
            }
            this.pageSize = pageSize;
            return this;
        }
        /**
         * Page starts at 1, so this to skip 'X' pages of results
         * @param pageNumber
         * @returns
         */
        setPage(pageNumber) {
            if (pageNumber < 1) {
                throw new Error('pageNumber can not be below 1');
            }
            this.pageNumber = pageNumber;
            return this;
        }
        build() {
            return {
                take: this.pageSize,
                skip: (this.pageNumber - 1) * this.pageSize,
            };
        }
    }

    class RelevanceModifierBuilder {
        constructor() {
            this.modifiers = [];
        }
        addBrandIdRelevanceModifier(brandId, ifProductIsBrandMultiplyWeightBy = 1, ifProductIsNotBrandMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.BrandIdRelevanceModifier, Relewise.Client',
                ifProductIsBrandMultiplyWeightBy: ifProductIsBrandMultiplyWeightBy,
                ifProductIsNotBrandMultiplyWeightBy: ifProductIsNotBrandMultiplyWeightBy,
                brandId: brandId,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductAssortmentRelevanceModifier(assortments, multiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductAssortmentRelevanceModifier, Relewise.Client',
                assortments: assortments,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantAssortmentRelevanceModifier(assortments, multiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantAssortmentRelevanceModifier, Relewise.Client',
                assortments: assortments,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductCategoryIdRelevanceModifier(categoryId, evaluationScope, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductCategoryIdRelevanceModifier, Relewise.Client',
                categoryId: categoryId,
                evaluationScope: evaluationScope,
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductDataRelevanceModifier(key, conditions, multiplierSelector, mustMatchAllConditions = true, considerAsMatchIfKeyIsNotFound = false, filter) {
            var _a;
            const conditionBuilder = new ConditionBuilder();
            conditions(conditionBuilder);
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductDataRelevanceModifier, Relewise.Client',
                key: key,
                considerAsMatchIfKeyIsNotFound: considerAsMatchIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: (_a = conditionBuilder.build()) === null || _a === void 0 ? void 0 : _a.items,
                multiplierSelector: multiplierSelector,
                multiplyWeightBy: 0,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantDataRelevanceModifier(key, conditions, multiplierSelector, mustMatchAllConditions = true, considerAsMatchIfKeyIsNotFound = false, filter) {
            var _a;
            const conditionBuilder = new ConditionBuilder();
            conditions(conditionBuilder);
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantDataRelevanceModifier, Relewise.Client',
                key: key,
                considerAsMatchIfKeyIsNotFound: considerAsMatchIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: (_a = conditionBuilder.build()) === null || _a === void 0 ? void 0 : _a.items,
                multiplierSelector: multiplierSelector,
                multiplyWeightBy: 0,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductIdRelevanceModifier(productIds, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductIdRelevanceModifier, Relewise.Client',
                productIds: productIds,
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductListPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductListPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductSalesPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductSalesPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantListPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantListPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSalesPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSalesPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSpecificationsInCommonRelevanceModifier(specificationKeysAndMultipliers, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSpecificationsInCommonRelevanceModifier, Relewise.Client',
                specificationKeysAndMultipliers,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSpecificationValueRelevanceModifier(key, value, ifIdenticalMultiplyWeightBy = 1, ifNotIdenticalMultiplyWeightBy = 0, ifSpecificationKeyNotFoundApplyNotEqualMultiplier = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSpecificationValueRelevanceModifier, Relewise.Client',
                key,
                value,
                ifIdenticalMultiplyWeightBy,
                ifNotIdenticalMultiplyWeightBy,
                ifSpecificationKeyNotFoundApplyNotEqualMultiplier,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductRecentlyPurchasedByUserRelevanceModifier(sinceUtc, ifNotPreviouslyPurchasedByUserMultiplyWeightBy = 1, ifPreviouslyPurchasedByUserMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductRecentlyPurchasedByUserRelevanceModifier, Relewise.Client',
                ifNotPreviouslyPurchasedByUserMultiplyWeightBy,
                ifPreviouslyPurchasedByUserMultiplyWeightBy,
                sinceUtc: sinceUtc.toJSON(),
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductRecentlyViewedByUserRelevanceModifier(sinceUtc, ifNotPreviouslyViewedByUserMultiplyWeightBy = 1, ifPreviouslyViewedByUserMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductRecentlyViewedByUserRelevanceModifier, Relewise.Client',
                ifNotPreviouslyViewedByUserMultiplyWeightBy,
                ifPreviouslyViewedByUserMultiplyWeightBy,
                sinceUtc: sinceUtc.toJSON(),
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addUserFavoriteProductRelevanceModifier(sinceMinutesAgo, ifNotPurchasedBaseWeight = 1, mostRecentPurchaseWeight = 1, numberOfPurchasesWeight = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.UserFavoriteProductRelevanceModifier, Relewise.Client',
                ifNotPurchasedBaseWeight,
                mostRecentPurchaseWeight,
                numberOfPurchasesWeight,
                sinceMinutesAgo: sinceMinutesAgo,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        build() {
            return this.modifiers.length === 0
                ? null
                : { items: this.modifiers };
        }
    }

    class DataObjectFacetBuilder {
        constructor() {
            this.facets = [];
        }
        addDataObjectFacet(key, builder, filter, facetSettings) {
            var _a, _b;
            const facetBuilder = new DataObjectFacetBuilder();
            if (builder) {
                builder(facetBuilder);
            }
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            if (filter === null || filter === void 0 ? void 0 : filter.conditions) {
                filter === null || filter === void 0 ? void 0 : filter.conditions(conditionsBuilder);
            }
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectFacet, Relewise.Client',
                field: 'Data',
                key: key,
                items: (_a = facetBuilder.build()) !== null && _a !== void 0 ? _a : [],
                filter: {
                    conditions: (_b = conditionsBuilder.build()) !== null && _b !== void 0 ? _b : [],
                    take: filter === null || filter === void 0 ? void 0 : filter.take,
                    skip: filter === null || filter === void 0 ? void 0 : filter.skip,
                },
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addStringFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectStringValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addBooleanFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectBooleanValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                settings: facetSettings,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
            };
            this.facets.push(facet);
            return this;
        }
        build() {
            return this.facets.length === 0
                ? null
                : this.facets;
        }
    }

    class FacetBuilder {
        constructor() {
            this.facets = [];
        }
        //#region Product
        addCategoryFacet(categorySelectionStrategy, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryHierarchyFacet(categorySelectionStrategy, selectedValues = null, selectedPropertiesSettings, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryHierarchyFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
                selectedPropertiesSettings: selectedPropertiesSettings ? Object.assign({ $type: 'Relewise.Client.Requests.Shared.SelectedProductCategoryPropertiesSettings, Relewise.Client' }, selectedPropertiesSettings) : undefined,
            };
            this.facets.push(facet);
            return this;
        }
        addContentCategoryHierarchyFacet(categorySelectionStrategy, selectedValues = null, selectedPropertiesSettings, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryHierarchyFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
                selectedPropertiesSettings: selectedPropertiesSettings ? Object.assign({ $type: 'Relewise.Client.Requests.Shared.SelectedContentCategoryPropertiesSettings, Relewise.Client' }, selectedPropertiesSettings) : undefined,
            };
            this.facets.push(facet);
            return this;
        }
        addBrandFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.BrandFacet, Relewise.Client',
                field: 'Brand',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductAssortmentFacet(selectionStrategy, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                assortmentSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addVariantSpecificationFacet(key, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.VariantSpecificationFacet, Relewise.Client',
                field: 'VariantSpecification',
                key: key,
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleRangeFacet(key, selectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selected,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleRangesFacet(key, selectionStrategy, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                dataSelectionStrategy: selectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataStringValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataBooleanValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addSalesPriceRangeFacet(priceSelectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangeFacet, Relewise.Client',
                field: 'SalesPrice',
                selected: selected,
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addListPriceRangeFacet(priceSelectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangeFacet, Relewise.Client',
                field: 'ListPrice',
                selected: selected,
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addListPriceRangesFacet(priceSelectionStrategy, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangesFacet, Relewise.Client',
                field: 'ListPrice',
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataObjectFacet(key, selectionStrategy, builder, filter, facetSettings) {
            var _a, _b;
            const facetBuilder = new DataObjectFacetBuilder();
            if (builder) {
                builder(facetBuilder);
            }
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            if (filter === null || filter === void 0 ? void 0 : filter.conditions) {
                filter === null || filter === void 0 ? void 0 : filter.conditions(conditionsBuilder);
            }
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataObjectFacet, Relewise.Client',
                field: 'Data',
                items: (_a = facetBuilder.build()) !== null && _a !== void 0 ? _a : [],
                filter: {
                    conditions: (_b = conditionsBuilder.build()) !== null && _b !== void 0 ? _b : [],
                    take: filter === null || filter === void 0 ? void 0 : filter.take,
                    skip: filter === null || filter === void 0 ? void 0 : filter.skip,
                },
                dataSelectionStrategy: selectionStrategy,
                settings: facetSettings,
                key: key,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        //#region Content
        addContentAssortmentFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                selected: selected,
                key: key,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataStringValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataStringValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataBooleanValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        //#region ProductCategories
        addProductCategoryAssortmentFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                selected: selected,
                key: key,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataStringValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataStringValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataBooleanValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        build() {
            return this.facets.length === 0
                ? null
                : {
                    items: this.facets,
                    $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.FacetQuery, Relewise.Client',
                };
        }
        mapSelectedDoubleRange(lowerBound, upperBound) {
            let selected = null;
            const lowerBoundHasValue = lowerBound !== null && lowerBound !== undefined;
            const upperBoundHasValue = upperBound !== null && upperBound !== undefined;
            if (lowerBoundHasValue || upperBoundHasValue) {
                selected = {};
                if (lowerBoundHasValue)
                    selected.lowerBoundInclusive = lowerBound;
                if (upperBoundHasValue)
                    selected.upperBoundInclusive = upperBound;
            }
            return selected;
        }
    }

    class ProductSortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByProductData(key, selectionStrategy, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client',
                dataSelectionStrategy: selectionStrategy,
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductAttribute(attribute, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductVariantAttribute(attribute, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductVariantAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductVariantSpecification(key, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductVariantSpecificationSorting, Relewise.Client',
                key,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ProductSortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
                thenByBuilder.build();
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class ContentSortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByContentData(key, order = 'Descending', mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentDataSorting, Relewise.Client',
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentAttribute(attribute, order, mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ContentSortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
                thenByBuilder.build();
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class ProductCategorySortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByProductCategoryData(key, order = 'Descending', mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryDataSorting, Relewise.Client',
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryAttribute(attribute, order, mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ProductCategorySortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class SearchRequestBuilder {
        constructor(settings) {
            this.settings = settings;
            this.filterBuilder = new FilterBuilder();
            this.postFilterBuilder = new FilterBuilder();
            this.relevanceModifiersBuilder = new RelevanceModifierBuilder();
        }
        /**
         * Adds filters to the request
         * @param filterBuilder
         * @returns
         */
        filters(filterBuilder) {
            filterBuilder(this.filterBuilder);
            return this;
        }
        /**
         * Adds post filters to the request
         * @param filterBuilder
         * @returns
         */
        postFilters(filterBuilder) {
            filterBuilder(this.postFilterBuilder);
            return this;
        }
        relevanceModifiers(relevanceModifiersBuilder) {
            relevanceModifiersBuilder(this.relevanceModifiersBuilder);
            return this;
        }
        /**
         * Use only when a specific index different from the 'default'-index is needed
         * @param id
         * @returns
         */
        setIndex(id) {
            this.indexId = id;
            return this;
        }
        baseBuild() {
            return Object.assign(Object.assign(Object.assign({}, (this.settings && {
                currency: { value: this.settings.currency },
                language: { value: this.settings.language },
                displayedAtLocation: this.settings.displayedAtLocation,
                user: this.settings.user,
            })), { filters: this.filterBuilder.build(), postFilters: this.postFilterBuilder.build(), relevanceModifiers: this.relevanceModifiersBuilder.build() }), (this.indexId && { indexSelector: { id: this.indexId } }));
        }
    }

    class ContentSearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ContentSortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ContentSearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setContentProperties(contentProperties) {
            this.searchSettings.selectedContentProperties = contentProperties;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ContentSearchRequest, Relewise.Client' }, this.baseBuild()), { settings: this.searchSettings, take,
                skip, term: this.term, facets: this.facetBuilder.build(), sorting: this.sortingBuilder.build() });
        }
    }

    class ProductCategorySearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ProductCategorySortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ProductCategorySearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setSelectedCategoryProperties(productCategoryProperties) {
            this.searchSettings.selectedCategoryProperties = productCategoryProperties;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        /**
         * Set the term used to filter product categories by
         */
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ProductCategorySearchRequest, Relewise.Client' }, this.baseBuild()), { take,
                skip, term: this.term, facets: this.facetBuilder.build(), settings: this.searchSettings, sorting: this.sortingBuilder.build() });
        }
    }

    class ProductSearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ProductSortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ProductSearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setSelectedProductProperties(productProperties) {
            this.searchSettings.selectedProductProperties = productProperties;
            return this;
        }
        setSelectedVariantProperties(variantProperties) {
            this.searchSettings.selectedVariantProperties = variantProperties;
            return this;
        }
        setSelectedBrandProperties(brandProperties) {
            this.searchSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setVariantSearchSettings(variantSearchSettings) {
            this.searchSettings.variantSettings = variantSearchSettings;
            return this;
        }
        setExplodedVariants(count) {
            this.searchSettings.explodedVariants = count;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        /**
         * Set the term used to filter products by
         */
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ProductSearchRequest, Relewise.Client' }, this.baseBuild()), { take,
                skip, term: this.term, facets: this.facetBuilder.build(), settings: this.searchSettings, sorting: this.sortingBuilder.build() });
        }
    }

    class SearchCollectionBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.requests = [];
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        build() {
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.SearchRequestCollection, Relewise.Client' }, this.baseBuild()), { requests: this.requests });
        }
    }

    class SearchTermPredictionBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.count = 0;
            this.term = '';
            this.targetEntityTypes = null;
        }
        take(count) {
            this.count = count;
            return this;
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        addEntityType(...types) {
            this.targetEntityTypes = types;
            return this;
        }
        build() {
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.SearchTermPredictionRequest, Relewise.Client' }, this.baseBuild()), { term: this.term, take: this.count, settings: {
                    $type: 'Relewise.Client.Requests.Search.Settings.SearchTermPredictionSettings, Relewise.Client',
                    targetEntityTypes: this.targetEntityTypes,
                } });
        }
    }

    class RecommendationRequestBuilder {
        constructor(settings) {
            this.settings = settings;
            this.filterBuilder = new FilterBuilder();
            this.relevanceModifiersBuilder = new RelevanceModifierBuilder();
        }
        /**
         * Adds filters to the request
         * @param filterBuilder
         * @returns
         */
        filters(filterBuilder) {
            filterBuilder(this.filterBuilder);
            return this;
        }
        relevanceModifiers(relevanceModifiersBuilder) {
            relevanceModifiersBuilder(this.relevanceModifiersBuilder);
            return this;
        }
        baseBuild() {
            var _a, _b;
            return {
                currency: { value: this.settings.currency },
                user: this.settings.user,
                language: { value: this.settings.language },
                displayedAtLocationType: this.settings.displayedAtLocation,
                filters: (_a = this.filterBuilder.build()) !== null && _a !== void 0 ? _a : {},
                relevanceModifiers: (_b = this.relevanceModifiersBuilder.build()) !== null && _b !== void 0 ? _b : {},
            };
        }
    }

    class ContentSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedContentProperties(contentProperties) {
            this.recommendationSettings.selectedContentProperties = contentProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class ContentsRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctContentsAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctContentsAcrossResults(distinctContentsAcrossResults = true) {
            this.distinctContentsAcrossResults = distinctContentsAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ContentRecommendationRequestCollection, Relewise.Client',
                requireDistinctContentsAcrossResults: this.distinctContentsAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ContentsViewedAfterViewingContentBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setContentId(contentId) {
            this.id = contentId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingContentRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentId: this.id });
            return request;
        }
    }

    class ContentsViewedAfterViewingMultipleContentsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.ids = [];
        }
        setContentIds(...ids) {
            this.ids = ids;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingMultipleContentsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentIds: this.ids });
            return request;
        }
    }

    class ContentsViewedAfterViewingMultipleProductsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.products = [];
        }
        addProduct(product) {
            this.products.push(product);
            return this;
        }
        addProducts(products) {
            products.forEach(x => this.products.push(x));
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingMultipleProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantIds: this.products });
            return request;
        }
    }

    class ContentsViewedAfterViewingProductBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.productAndVariantId = {
                productId: '',
            };
        }
        product(product) {
            this.productAndVariantId = product;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class PersonalContentRecommendationBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalContentRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularContentsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularContentsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, sinceMinutesAgo: this.since });
            return request;
        }
    }

    class ContentCategoriesRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctCategoriesAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctCategoriesAcrossResults(distinctCategoriesAcrossResults = true) {
            this.distinctCategoriesAcrossResults = distinctCategoriesAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ContentRecommendationRequestCollection, Relewise.Client',
                requireDistinctCategoriesAcrossResults: this.distinctCategoriesAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ContentCategorySettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedContentCategoryProperties(ContentCategoryProperties) {
            this.recommendationSettings.selectedContentCategoryProperties = ContentCategoryProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalContentCategoryRecommendationBuilder extends ContentCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, contentViews: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalContentCategoryRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularContentCategoriesRecommendationBuilder extends ContentCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, contentViews: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularContentCategoriesRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class BrandSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedBrandProperties(brandProperties) {
            this.recommendationSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalBrandRecommendationBuilder extends BrandSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { brandViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalBrandRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularBrandsRecommendationBuilder extends BrandSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { brandViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularBrandsRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class ProductCategorySettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setProductCategoryProperties(ProductCategoryProperties) {
            this.recommendationSettings.selectedProductCategoryProperties = ProductCategoryProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalProductCategoryRecommendationBuilder extends ProductCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalProductCategoryRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularProductCategoriesRecommendationBuilder extends ProductCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularProductCategoriesRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class ProductCategoriesRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctCategoriesAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctCategoriesAcrossResults(distinctCategoriesAcrossResults = true) {
            this.distinctCategoriesAcrossResults = distinctCategoriesAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ProductCategoryRecommendationRequestCollection, Relewise.Client',
                requireDistinctCategoriesAcrossResults: this.distinctCategoriesAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ProductSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                recommendVariant: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedProductProperties(productProperties) {
            this.recommendationSettings.selectedProductProperties = productProperties;
            return this;
        }
        setSelectedVariantProperties(variantProperties) {
            this.recommendationSettings.selectedVariantProperties = variantProperties;
            return this;
        }
        setSelectedBrandProperties(brandProperties) {
            this.recommendationSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        allowProductsCurrentlyInCart(allowed = true) {
            this.recommendationSettings.allowProductsCurrentlyInCart = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
        recommendVariant(recommend = true) {
            this.recommendationSettings.recommendVariant = recommend;
            return this;
        }
    }

    class PurchasedWithCurrentCartBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithCurrentCartRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class BySingleProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.productAndVariantId = null;
        }
        product(product) {
            this.productAndVariantId = product;
            return this;
        }
    }

    class ProductsViewedAfterViewingProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            if (this.productAndVariantId === null) {
                throw new Error('Must specificy a product');
            }
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ProductsViewedAfterViewingProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class ProductsViewedAfterViewingContentBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setContentId(contentId) {
            this.id = contentId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ProductsViewedAfterViewingContentRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentId: this.id });
            return request;
        }
    }

    class PersonalProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalProductRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.basedOnSelection = 'MostPurchased';
        }
        basedOn(basedOn) {
            this.basedOnSelection = basedOn;
            return this;
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, basedOn: this.basedOnSelection, sinceMinutesAgo: this.since });
            return request;
        }
    }

    class RecentlyViewedProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.RecentlyViewedProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class SortVariantsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setProductId(productId) {
            this.id = productId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SortVariantsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productId: this.id });
            return request;
        }
    }

    class ProductsRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctProductsAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctProductsAcrossResults(distinctProductsAcrossResults = true) {
            this.distinctProductsAcrossResults = distinctProductsAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ProductRecommendationRequestCollection, Relewise.Client',
                requireDistinctProductsAcrossResults: this.distinctProductsAcrossResults,
                requests: this.requests,
            };
        }
    }

    class PurchasedWithMultipleProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.products = [];
        }
        addProduct(product) {
            this.products.push(product);
            return this;
        }
        addProducts(products) {
            products.forEach(x => this.products.push(x));
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithMultipleProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantIds: this.products });
            return request;
        }
    }

    class PurchasedWithProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            if (this.productAndVariantId === null) {
                throw new Error('Must specificy a product');
            }
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class SearchTermBasedProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.term = '';
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SearchTermBasedProductRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, term: this.term });
            return request;
        }
    }

    class SortProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.ids = [];
        }
        setProductIds(productIds) {
            this.ids = productIds;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SortProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productIds: this.ids });
            return request;
        }
    }

    class SimilarProductsProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.evaluationSettings = null;
            this.considerAlreadyKnownInformationAboutProduct = false;
            this.productData = null;
        }
        setSimilarProductsEvaluationSettings(settings) {
            this.evaluationSettings = settings;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SimilarProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, existingProductId: this.productAndVariantId, considerAlreadyKnownInformationAboutProduct: this.considerAlreadyKnownInformationAboutProduct, productData: this.productData, evaluationSettings: this.evaluationSettings });
            return request;
        }
    }

    class PopularSearchTermsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                numberOfRecommendations: 10,
            };
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        addEntityType(...types) {
            this.recommendationSettings.targetEntityTypes = types;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularSearchTermsRecommendationRequest, Relewise.Client' }, this.baseBuild()), { term: this.term, settings: this.recommendationSettings });
            return request;
        }
    }

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    var version = { tag: '1.14.0' };

    class RelewiseClient {
        constructor(datasetId, apiKey, options) {
            this.datasetId = datasetId;
            this.apiKey = apiKey;
            this._serverUrl = 'https://api.relewise.com';
            this._urlPath = 'v1';
            if (!datasetId)
                throw new Error('Dataset id cannot be null or empty. Please contact Relewise if you don\'t have an account already or would like a free demo license');
            if (!apiKey)
                throw new Error('API Key secret cannot be null or empty. Please contact Relewise support if you don\'t know the apiKeySecret for your datasetId.');
            if (options === null || options === void 0 ? void 0 : options.serverUrl) {
                this._serverUrl = options.serverUrl;
            }
        }
        get serverUrl() {
            return this._serverUrl;
        }
        request(name, data) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKeyHeader = `APIKey ${this.apiKey}`;
                const requestUrl = this.createRequestUrl(this._serverUrl, this.datasetId, this._urlPath, name);
                const response = yield fetch__default["default"](requestUrl, {
                    method: 'POST',
                    headers: {
                        Authorization: apiKeyHeader,
                        'Content-Type': 'application/json',
                        'X-Relewise-Version': version.tag,
                    },
                    body: JSON.stringify(data),
                });
                try {
                    return yield response.json();
                }
                catch (err) {
                    return undefined;
                }
            });
        }
        createRequestUrl(baseUrl, ...segments) {
            const joinedSegments = segments.join('/');
            return baseUrl.endsWith('/')
                ? baseUrl.concat(joinedSegments)
                : baseUrl.concat('/', joinedSegments);
        }
    }

    class Tracker extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        trackOrder({ user, subtotal, orderNumber, lineItems, cartName = 'default', trackingNumber }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackOrderRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackOrderRequest, Relewise.Client',
                    order: {
                        $type: 'Relewise.Client.DataTypes.Order, Relewise.Client',
                        lineItems: lineItems.map(l => (Object.assign(Object.assign({ product: {
                                id: l.productId,
                            } }, (l.variantId && { variant: { id: l.variantId } })), { lineTotal: l.lineTotal, quantity: l.quantity }))),
                        subtotal: { amount: subtotal.amount, currency: { value: subtotal.currency } },
                        orderNumber: orderNumber,
                        trackingNumber: trackingNumber,
                        cartName: cartName,
                        user: user,
                    },
                });
            });
        }
        trackCart({ user, subtotal, lineItems, cartName = 'default' }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackCartRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackCartRequest, Relewise.Client',
                    cart: {
                        $type: 'Relewise.Client.DataTypes.Cart, Relewise.Client',
                        lineItems: lineItems.map(l => (Object.assign(Object.assign({ product: {
                                id: l.productId,
                            } }, (l.variantId && { variant: { id: l.variantId } })), { lineTotal: l.lineTotal, quantity: l.quantity }))),
                        subtotal: { amount: subtotal.amount, currency: { value: subtotal.currency } },
                        name: cartName,
                        user: user,
                    },
                });
            });
        }
        trackProductView({ productId, variantId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackProductViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackProductViewRequest, Relewise.Client',
                    productView: Object.assign(Object.assign({ $type: 'Relewise.Client.DataTypes.ProductView, Relewise.Client', product: {
                            id: productId,
                        } }, (variantId && { variant: { id: variantId } })), { user: user }),
                });
            });
        }
        trackProductCategoryView({ idPath, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackProductCategoryViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackProductCategoryViewRequest, Relewise.Client',
                    productCategoryView: {
                        $type: 'Relewise.Client.DataTypes.ProductCategoryView, Relewise.Client',
                        idPath: idPath,
                        user: user,
                    },
                });
            });
        }
        trackContentView({ contentId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackContentViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackContentViewRequest, Relewise.Client',
                    contentView: {
                        $type: 'Relewise.Client.DataTypes.ContentView, Relewise.Client',
                        content: {
                            id: contentId,
                        },
                        user: user,
                    },
                });
            });
        }
        trackContentCategoryView({ idPath, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackContentCategoryViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackContentCategoryViewRequest, Relewise.Client',
                    contentCategoryView: {
                        $type: 'Relewise.Client.DataTypes.ContentCategoryView, Relewise.Client',
                        idPath: idPath,
                        user: user,
                    },
                });
            });
        }
        trackBrandView({ brandId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackBrandViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackBrandViewRequest, Relewise.Client',
                    brandView: {
                        $type: 'Relewise.Client.DataTypes.BrandView, Relewise.Client',
                        brand: {
                            id: brandId,
                        },
                        user: user,
                    },
                });
            });
        }
        trackSearchTerm({ term, language, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackSearchTermRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackSearchTermRequest, Relewise.Client',
                    searchTerm: {
                        $type: 'Relewise.Client.DataTypes.SearchTerm, Relewise.Client',
                        language: {
                            value: language,
                        },
                        term: term,
                        user: user,
                    },
                });
            });
        }
        trackUserUpdate({ user, updateKind = 'UpdateAndAppend' }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackUserUpdateRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackUserUpdateRequest, Relewise.Client',
                    userUpdate: {
                        $type: 'Relewise.Client.DataTypes.UserUpdate, Relewise.Client',
                        user: user,
                        kind: updateKind,
                    },
                });
            });
        }
    }

    class Searcher extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        searchProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductSearchRequest', request);
            });
        }
        searchProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductCategorySearchRequest', request);
            });
        }
        searchContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentSearchRequest', request);
            });
        }
        searchTermPrediction(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchTermPredictionRequest', request);
            });
        }
        batch(requestCollections) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchRequestCollection', requestCollections);
            });
        }
    }

    class Recommender extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        recommendPopularSearchTerms(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularSearchTermsRecommendationRequest', request);
            });
        }
        //#region Brands
        recommendPersonalBrands(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalBrandRecommendationRequest', request);
            });
        }
        recommendPopularBrands(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularBrandsRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Content Categories
        recommendPersonalContentCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalContentCategoryRecommendationRequest', request);
            });
        }
        recommendPopularContentCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentCategoriesRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Product Categories
        recommendPersonalProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalProductCategoryRecommendationRequest', request);
            });
        }
        recommendPopularProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularProductCategoriesRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Products
        recommendPurchasedWithProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithProductRequest', request);
            });
        }
        recommendPurchasedWithMultipleProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithMultipleProductsRequest', request);
            });
        }
        sortVariants(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SortVariantsRequest', request);
            });
        }
        sortProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SortProductsRequest', request);
            });
        }
        recommendSimilarProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SimilarProductsRequest', request);
            });
        }
        recommendSearchTermBasedProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchTermBasedProductRecommendationRequest', request);
            });
        }
        recentlyViewedProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('RecentlyViewedProductsRequest', request);
            });
        }
        recommendPurchasedWithCurrentCart(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithCurrentCartRequest', request);
            });
        }
        recommendProductsViewedAfterViewingProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductsViewedAfterViewingProductRequest', request);
            });
        }
        recommendProductsViewedAfterViewingContent(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductsViewedAfterViewingContentRequest', request);
            });
        }
        recommendPopularProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularProductsRequest', request);
            });
        }
        recommendPersonalProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalProductRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Content
        recommendPopularContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentsRequest', request);
            });
        }
        recommendPersonalContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentsRequest', request);
            });
        }
        recommendContentsViewedAfterViewingProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingProductRequest', request);
            });
        }
        recommendContentsViewedAfterViewingMultipleProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingProductRequest', request);
            });
        }
        recommendContentsViewedAfterViewingMultipleContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingMultipleContentsRequest', request);
            });
        }
        recommendContentsViewedAfterViewingContent(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingContentRequest', request);
            });
        }
        //#endregion
        //#region Batching 
        batchProductRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductRecommendationRequestCollection', request);
            });
        }
        batchContentRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentRecommendationRequestCollection', request);
            });
        }
        batchContentCategoryRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentCategoryRecommendationRequestCollection', request);
            });
        }
        batchProductCategoryRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductCategoryRecommendationRequestCollection', request);
            });
        }
    }

    class UserFactory {
        static anonymous(user) {
            return Object.assign({}, user);
        }
        static byAuthenticatedId(authenticatedId, temporaryId, user) {
            return Object.assign(Object.assign({ authenticatedId }, (temporaryId && { temporaryId })), user);
        }
        static byTemporaryId(temporaryId, user) {
            return Object.assign(Object.assign({}, user), { temporaryId });
        }
        static byIdentifier(key, value, user) {
            return Object.assign(Object.assign({}, user), { identifiers: { [key]: value } });
        }
        static byIdentifiers(identifiers, user) {
            return Object.assign({ identifiers }, user);
        }
        static byEmail(email, user) {
            return Object.assign({ email }, user);
        }
        static byFingerprint(fingerprint, user) {
            return Object.assign({ fingerprint }, user);
        }
    }

    class DataValueFactory {
        static string(value) {
            return new StringDataValue(value);
        }
        static stringCollection(collection) {
            return new StringCollectionDataValue(collection);
        }
        static number(value) {
            return new NumberDataValue(value);
        }
        static doubleCollection(collection) {
            return new DoubleCollectionDataValue(collection);
        }
        static boolean(value) {
            return new BooleanDataValue(value);
        }
        static booleanCollection(collection) {
            return new BooleanCollectionDataValue(collection);
        }
        static multiCurrency(values) {
            return new MultiCurrencyDataValue(values);
        }
        static multilingual(values) {
            return new MultilingualDataValue(values);
        }
        static multilingualCollection(values) {
            return new MultilingualCollectionDataValue(values);
        }
        static object(data) {
            return new ObjectDataValue(data);
        }
        static objectCollection(objects) {
            return new ObjectCollectionDataValue(objects);
        }
    }

    class ValueSelectorFactory {
        static dataDoubleSelector(key) {
            return {
                $type: 'Relewise.Client.Requests.ValueSelectors.DataDoubleSelector, Relewise.Client',
                key: key,
            };
        }
        static fixedDoubleValueSelector(value) {
            return {
                $type: 'Relewise.Client.Requests.ValueSelectors.FixedDoubleValueSelector, Relewise.Client',
                value: value,
            };
        }
    }

    exports.BooleanCollectionDataValue = BooleanCollectionDataValue;
    exports.BooleanDataValue = BooleanDataValue;
    exports.BrandSettingsRecommendationBuilder = BrandSettingsRecommendationBuilder;
    exports.BySingleProductRecommendationBuilder = BySingleProductRecommendationBuilder;
    exports.ConditionBuilder = ConditionBuilder;
    exports.ContentCategoriesRecommendationCollectionBuilder = ContentCategoriesRecommendationCollectionBuilder;
    exports.ContentCategorySettingsRecommendationBuilder = ContentCategorySettingsRecommendationBuilder;
    exports.ContentSearchBuilder = ContentSearchBuilder;
    exports.ContentSettingsRecommendationBuilder = ContentSettingsRecommendationBuilder;
    exports.ContentSortingBuilder = ContentSortingBuilder;
    exports.ContentsRecommendationCollectionBuilder = ContentsRecommendationCollectionBuilder;
    exports.ContentsViewedAfterViewingContentBuilder = ContentsViewedAfterViewingContentBuilder;
    exports.ContentsViewedAfterViewingMultipleContentsBuilder = ContentsViewedAfterViewingMultipleContentsBuilder;
    exports.ContentsViewedAfterViewingMultipleProductsBuilder = ContentsViewedAfterViewingMultipleProductsBuilder;
    exports.ContentsViewedAfterViewingProductBuilder = ContentsViewedAfterViewingProductBuilder;
    exports.DataObjectFacetBuilder = DataObjectFacetBuilder;
    exports.DataObjectFilterConditionBuilder = DataObjectFilterConditionBuilder;
    exports.DataValueBase = DataValueBase;
    exports.DataValueFactory = DataValueFactory;
    exports.DoubleCollectionDataValue = DoubleCollectionDataValue;
    exports.FacetBuilder = FacetBuilder;
    exports.FilterBuilder = FilterBuilder;
    exports.MultiCurrencyDataValue = MultiCurrencyDataValue;
    exports.MultilingualCollectionDataValue = MultilingualCollectionDataValue;
    exports.MultilingualDataValue = MultilingualDataValue;
    exports.NumberDataValue = NumberDataValue;
    exports.ObjectCollectionDataValue = ObjectCollectionDataValue;
    exports.ObjectDataValue = ObjectDataValue;
    exports.PaginationBuilder = PaginationBuilder;
    exports.PersonalBrandRecommendationBuilder = PersonalBrandRecommendationBuilder;
    exports.PersonalContentCategoryRecommendationBuilder = PersonalContentCategoryRecommendationBuilder;
    exports.PersonalContentRecommendationBuilder = PersonalContentRecommendationBuilder;
    exports.PersonalProductCategoryRecommendationBuilder = PersonalProductCategoryRecommendationBuilder;
    exports.PersonalProductRecommendationBuilder = PersonalProductRecommendationBuilder;
    exports.PopularBrandsRecommendationBuilder = PopularBrandsRecommendationBuilder;
    exports.PopularContentCategoriesRecommendationBuilder = PopularContentCategoriesRecommendationBuilder;
    exports.PopularContentsBuilder = PopularContentsBuilder;
    exports.PopularProductCategoriesRecommendationBuilder = PopularProductCategoriesRecommendationBuilder;
    exports.PopularProductsBuilder = PopularProductsBuilder;
    exports.PopularSearchTermsRecommendationBuilder = PopularSearchTermsRecommendationBuilder;
    exports.ProductCategoriesRecommendationCollectionBuilder = ProductCategoriesRecommendationCollectionBuilder;
    exports.ProductCategorySearchBuilder = ProductCategorySearchBuilder;
    exports.ProductCategorySettingsRecommendationBuilder = ProductCategorySettingsRecommendationBuilder;
    exports.ProductCategorySortingBuilder = ProductCategorySortingBuilder;
    exports.ProductSearchBuilder = ProductSearchBuilder;
    exports.ProductSettingsRecommendationBuilder = ProductSettingsRecommendationBuilder;
    exports.ProductSortingBuilder = ProductSortingBuilder;
    exports.ProductsRecommendationCollectionBuilder = ProductsRecommendationCollectionBuilder;
    exports.ProductsViewedAfterViewingContentBuilder = ProductsViewedAfterViewingContentBuilder;
    exports.ProductsViewedAfterViewingProductBuilder = ProductsViewedAfterViewingProductBuilder;
    exports.PurchasedWithCurrentCartBuilder = PurchasedWithCurrentCartBuilder;
    exports.PurchasedWithMultipleProductsBuilder = PurchasedWithMultipleProductsBuilder;
    exports.PurchasedWithProductBuilder = PurchasedWithProductBuilder;
    exports.RecentlyViewedProductsBuilder = RecentlyViewedProductsBuilder;
    exports.RecommendationRequestBuilder = RecommendationRequestBuilder;
    exports.Recommender = Recommender;
    exports.RelevanceModifierBuilder = RelevanceModifierBuilder;
    exports.RelewiseClient = RelewiseClient;
    exports.SearchCollectionBuilder = SearchCollectionBuilder;
    exports.SearchRequestBuilder = SearchRequestBuilder;
    exports.SearchTermBasedProductRecommendationBuilder = SearchTermBasedProductRecommendationBuilder;
    exports.SearchTermPredictionBuilder = SearchTermPredictionBuilder;
    exports.Searcher = Searcher;
    exports.SimilarProductsProductBuilder = SimilarProductsProductBuilder;
    exports.SortProductsBuilder = SortProductsBuilder;
    exports.SortVariantsBuilder = SortVariantsBuilder;
    exports.StringCollectionDataValue = StringCollectionDataValue;
    exports.StringDataValue = StringDataValue;
    exports.Tracker = Tracker;
    exports.UserFactory = UserFactory;
    exports.ValueSelectorFactory = ValueSelectorFactory;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=relewise-client.js.map
